<script setup lang="ts">
import { classname } from '@/js/utils.js';
import BaseCheckbox from '@/js/vue/base/base-checkbox.vue';
import BaseLink from '@/js/vue/base/base-link.vue';
import { computed } from 'vue';

const { productId } = defineProps<{ productId: number, url: string, image: string, name: string, price: string }>();
const cn = classname('product-service');
const productIds = defineModel<number[]>('productIds');
const isChecked = computed(() => productIds.value.includes(productId));

function updateCheckbox(checked: boolean) {
  if (checked && !productIds.value.includes(productId)) {
    productIds.value = [...productIds.value, productId];
  }
  else if (!checked) {
    productIds.value = productIds.value.filter(id => id !== productId);
  }
}
</script>

<template>
  <BaseCheckbox
    :class="cn()"
    :model-value="isChecked"
    @update:model-value="updateCheckbox"
  >
    <span :class="cn('image-wrapper')">
      <img
        :src="image"
        alt=""
      >
    </span>
    <span :class="cn('title-wrapper')">
      {{ name }}
      <BaseLink
        :href="url"
        target="_blank"
        :class="cn('link')"
      >
        Об услуге
      </BaseLink>
    </span>
    <span :class="cn('price')">{{ price }}</span>
  </BaseCheckbox>
</template>

<style lang="scss">
.product-service {
  display: grid;
  grid-gap: 34px;
  grid-template-areas: 'check image text price';
  grid-template-columns: 20px 70px 1fr auto;
  align-items: center;

  input[type='checkbox'] {
    grid-area: check;
  }

  &__image-wrapper {
    flex-shrink: 0;
    width: 74px;
    grid-area: image;

    img {
      width: 100%;
      max-width: 100%;
      height: auto;
      object-fit: cover;
    }
  }

  &__title-wrapper {
    display: flex;
    grid-gap: 6px;
    flex-direction: column;
    font-size: 14px;
    line-height: 1;
    grid-area: text;
    word-break: break-all;
  }

  &__link {
    font-size: 12px;
  }

  &__price {
    font-weight: 300;
    font-size: 16px;
    color: #000000;
    grid-area: price;
    white-space: nowrap;
  }

  @media screen and (max-width: 1200px) {
    grid-gap: 20px;
  }

  @media screen and (max-width: 500px) {
    grid-template-areas: 'check text' 'image price';
    grid-template-columns: auto auto;
    grid-row-gap: 10px;
    grid-column-gap: 20px;

    &__image-wrapper {
      width: 54px;
    }

    &__price {
      font-weight: 400;
      font-size: 24px;
      text-align: right;
    }
  }
}
</style>
